"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WasfatyDosage_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var WasfatyDosage_Factory = /** @class */ (function () {
    function WasfatyDosage_Factory() {
    }
    WasfatyDosage_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            Code: model.Code,
            Description: model.Description,
            Id: model.Id,
        };
        return result;
    };
    WasfatyDosage_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            Code: model.Code,
            Description: model.Description,
            Id: model.Id,
        };
        return result;
    };
    return WasfatyDosage_Factory;
}());
exports.WasfatyDosage_Factory = WasfatyDosage_Factory;
